"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = CheckRoutingNumberInput;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function CheckRoutingNumberInput() {
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "checkaba"
  });
}